





























































import Vue from "vue";
import { orderService } from "@/picking-portal/services/PPOrderService";
import { PPOrder } from "@/picking-portal/models/PPOrder";
import { PPSlotBooking } from "@/picking-portal/models/PPSlotBooking";
import { bookingService } from "@/picking-portal/services/PPBookingService";
import { storeService } from "@/common/services/StoreService";
import { PPOrderStatus, PPOrderStatusMap } from "@/picking-portal/enums/PPOrderStatus";
import { DateTime } from "luxon";
import { PPBookings } from "@/picking-portal/models/PPBookings";
import PPCollectOrderScanner from "@/picking-portal/components/PPCollectOrderScanner.vue";
import PPOrderListItem from "@/picking-portal/components/PPOrderListItem.vue";
import { PPClickAndCollectStatus } from "../enums/PPClickAndCollectStatus";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";

interface OrderBooking {
  order: PPOrder;
  booking: PPSlotBooking;
}

interface Filter {
  statuses: PPClickAndCollectStatus[];
}

interface SortOption {
  title: string;
  compareFn: (a: OrderBooking, b: OrderBooking) => number;
}

const sortOptions = [
  {
    title: "modules.packing-portal.components.order-list.sort-time-ascending",
    compareFn: (a: OrderBooking, b: OrderBooking): number => {
      return +new Date(a.booking.start) - +new Date(b.booking.start);
    },
  },
  {
    title: "modules.packing-portal.components.order-list.sort-time-descending",
    compareFn: (a: OrderBooking, b: OrderBooking): number => {
      return +new Date(b.booking.start) - +new Date(a.booking.start);
    },
  },
] as SortOption[];

export default Vue.extend({
  name: "PPOrderList",

  components: {
    PPCollectOrderScanner,
    PPOrderListItem,
  },
  props: {
    storeId: {
      type: String,
      required: true,
    },
    from: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isLoading: true,
      slot: undefined as PPBookings[] | undefined,
      bookings: [] as PPSlotBooking[],
      orderBookings: [] as OrderBooking[],
      orderReferences: [] as string[],
      PPOrderStatus,
      PPOrderStatusMap,
      filterStatuses: Array.from(PPOrderStatusMap.keys()),
      filter: { statuses: [] } as Filter,
      sortOptions,
      sortOption: sortOptions[0] as SortOption,
      storeService,
    };
  },
  computed: {
    breadcrumbs(): Array<Record<string, string | boolean>> {
      return this.$route?.meta?.breadCrumb({
        storeId: storeService.selectedStore,
        date: DateTime.now().toSQLDate(),
        from: DateTime.now().toSQLDate(),
        to: DateTime.now().toSQLDate(),
      });
    },
    sortedOrderBookings(): OrderBooking[] {
      return [...this.orderBookings]
        .filter((orderBooking) => {
          return this.filter.statuses.length === 0 || this.filter.statuses.includes(orderBooking.order.status);
        })
        .sort(this.sortOption.compareFn);
    },
    currentStore: function (): string {
      return this.storeService.selectedStore;
    },
  },
  watch: {
    currentStore: function (): void {
      this.changeStore();
    },
  },
  async mounted() {
    await this.getBookings();
  },
  methods: {
    getMobileClasses(): string {
      if (this.$vuetify.breakpoint.mobile) {
        return "px-0";
      } else {
        return "";
      }
    },
    async getBookings(): Promise<void> {
      this.isLoading = true;
      this.orderBookings = [];
      this.slot = await bookingService.getBookingsByTimeInterval(
        this.storeId,
        DateTime.fromISO(this.from),
        DateTime.fromISO(this.to).minus({ minutes: 1 })
      );
      if (this.slot) {
        for (const s of this.slot) {
          for (const bId of s.bookingIds) {
            const booking = await bookingService.get(this.storeId, bId);
            const order = await orderService.getFulfillment(booking.reference);
            if (order) {
              this.orderBookings.push({ order, booking });
            }
          }
        }
      }
      this.isLoading = false;
    },
    async cancelOrder(transactionId: string): Promise<void> {
      await orderService.cancelFulfillment(transactionId).then(async () => {
        if (this.orderBookings.length === 1) {
          this.$router.go(-1);
        } else {
          await this.getBookings();
        }
      });
    },
    setSortOrder(option: SortOption): void {
      this.sortOption = option;
    },
    async changeStore(): Promise<void> {
      await this.$router
        .push({
          name: RouteInfoMap.get(Paths.ClickAndCollect)?.name,
          query: {
            storeId: storeService.selectedStore.toString(),
            date: DateTime.now().toFormat("yyyy-MM-dd"),
          },
        })
        .catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
    },
  },
});
